import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { IoMdSearch } from 'react-icons/io';
import {  familySearchQuery } from '../utils/data';
import { client } from '../client';
import Spinner from './Spinner';

const AddFamily = ({ user, setView }) => {
    const [families, setFamilies] = useState([]);
    const [text, setText] = useState('Created');

    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (searchTerm !== '') {
            setLoading(true);
            const query = familySearchQuery(searchTerm.toLowerCase());
            client.fetch(query).then((data) => {
                setFamilies(data);
                setLoading(false);
                setView("Add Family");
            });
        } 
    }, [searchTerm]);

    if (!user) return <Spinner message="Loading profile" />;

    return (
        <div className="relative pb-2 h-full">
            <div className="flex flex-initial justify-center gap-2 w-auto h-auto rounded-md mt-5 bg-secondaryColor content-center">
                <div className="flex justify-start items-center w-full px-2 rounded-md bg-white border-none outline-none focus-within:shadow-sm">
                    <IoMdSearch fontSize={21} className="ml-1" />
                    <input
                        type="text"
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Search Family"
                        value={searchTerm}
                        // onFocus={() => navigate('/search')}
                        className="p-2 bg-white outline-none"
                    />
                </div>

                <div className="flex flex-initial gap-3 align-middle">
                    <button
                        type="button"
                        onClick={(e) => {
                            setText(e.target.textContent);
                        }}
                        className={`flex-1 bg-indigo-500 text-white font-bold p-2 rounded-full w-20 outline-none`}
                    >
                        Search
                    </button>
                </div>
            </div>
            <div className="flex flex-initial mt-5 w-4/5 gap-3 align-middle">
                    <NavLink
                        to={`/create-family`}
                        className={`flex-1 bg-indigo-500 text-white font-bold p-2 rounded-full w-20 outline-none text-center`}
                    >
                        Create Family
                    </NavLink>
                </div>

            {/* place holder for the families to be listed when searched */}
            {families?.length !== 0 ?
                <>
                    {searchTerm != '' &&
                        <div className='items-center px-5 gap-3'>
                            {families?.map((family) =>
                                <div className='flex-1 gap-2 md:gap-5 w-4/5 h-auto rounded-md mt-5  bg-secondaryColor content-center'>
                                    <NavLink
                                        to={`/Join-family/${family?._id}`}
                                        className='flex items-center px-5 gap-3 text-gray-500 hover:text-black transition-all duration-200 ease-in-out capitalize'
                                        key={family.familyName}
                                    >
                                        <img src={family.imageUrl + "?h=40"} className="w-8 h-8 rounded-full shadow-sm" />
                                        <h1>{family.familyName}</h1>
                                    </NavLink>
                                </div>
                            )}
                        </div>
                    }
                    <div>

                    </div>
                </>
                :
                <div className="flex justify-center font-bold items-center w-full text-1xl mt-2">
                    No Families Found! Create One Now?
                </div>
            }
            {loading && <Spinner message="Searching" />}

        </div>
    );
};

export default AddFamily